<template>
  <div>
    <section class="fullscreen flex-container">
      <Header />
    </section>
    <Content title="Flights" icon="plane-departure">
      <CopyWithImage
        flexDirection="column"
        :src="require('@/assets/images/flights.jpg')"
      >
        <p>
          There are two main options with flights. <b>Fly to George</b> or fly
          to <b>Cape Town</b>. We are recommending people fly in between the
          28th and the 30th and stay for as long as they need. Accomodation will
          be limited from the 2nd of December. So we will be heading towards
          Cape Town for some activities.
        </p>
      </CopyWithImage>

      <FlexContainer>
        <FlexItem size="50%" padding="large">
          <h2>Flying to George</h2>
          <p>
            This option is the most convenient for most people flying in to the
            wedding.
          </p>
          <ul>
            <li>
              <i class="fal fa-info-circle" /> Airport is 10 minutes from the
              house
            </li>
            <li><i class="fal fa-info-circle" /> Transfer in Johannesburg</li>
            <li>
              <i class="fal fa-info-circle" /> May miss out on activies near
              Cape Town
            </li>
          </ul>
          <ButtonLink
            type="primary"
            href="https://www.skyscanner.net/transport/flights/lhr/grj/191128/191212?adults=1&children=0&adultsv2=1&childrenv2=&infants=0&cabinclass=economy&rtn=1&preferdirects=false&outboundaltsenabled=false&inboundaltsenabled=false&locale=en-GB&currency=GBP&ref=day-view#results"
            target="_blank"
            icon="plane-departure"
            >Flights to George</ButtonLink
          >
        </FlexItem>
        <FlexItem size="50%" padding="large">
          <h2>Flying to Cape Town</h2>
          <p>
            We are planning to visit Cape Town after the wedding, which is 4.5
            hours west of George.
          </p>
          <ul>
            <li>
              <i class="fal fa-info-circle" /> If you fly to Cape Town you will
              need to hire a car or ride on a coach.
            </li>
            <li>
              <i class="fal fa-info-circle" /> More things to do in Cape Town
            </li>
            <li>
              <i class="fal fa-info-circle" /> Convenient for activity plans
              after the wedding.
            </li>
            <li>
              <i class="fal fa-info-circle" /> You will need to travel 4.5 hours
              to reach the wedding
            </li>
          </ul>
          <ButtonLink
            type="primary"
            href="https://www.skyscanner.net/transport/flights/lhr/cpt/191127/191204?adults=1&children=0&adultsv2=1&childrenv2=&infants=0&cabinclass=economy&rtn=1&preferdirects=false&outboundaltsenabled=false&inboundaltsenabled=false&locale=en-GB&currency=GBP&ref=day-view#results"
            target="_blank"
            icon="plane-departure"
            >Flights to Cape Town</ButtonLink
          >
        </FlexItem>
      </FlexContainer>
    </Content>
  </div>
</template>

<script>
import Header from '@/components/ui/Header.vue';
import Content from '@/components/ui/Content.vue';
import ButtonLink from '@/components/ui/ButtonLink.vue';
import FlexContainer from '@/components/ui/FlexContainer.vue';
import FlexItem from '@/components/ui/FlexItem.vue';
import CopyWithImage from '@/components/ui/CopyWithImage.vue';

export default {
  name: 'Flights',
  components: {
    Header,
    Content,
    FlexContainer,
    FlexItem,
    CopyWithImage,
    ButtonLink
  }
};
</script>

<style lang="scss" scoped>
> section:first-of-type {
  min-height: 10vh;

  @include respond-below(sm) {
    padding: $padding;
  }
}

.section__two {
  background: white;
}
</style>
